// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Components
import { BaseComponent } from './shared/components/base/base.component';

const routes: Routes = [
	{
		path: 'auth',
		loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
	},
	{
		path: 'public-error-page', // This is a route for error page when user is not logged in
		loadChildren: () => import('./modules/error/error.module').then((m) => m.ErrorModule),
	},
	{
		path: '',
		component: BaseComponent,
		children: [
			{
				path: 'eula',
				loadChildren: () => import('./modules/eula/eula.module').then((m) => m.EulaModule),
			},
			{
				path: 'job',
				loadChildren: () => import('./modules/job/job.module').then((m) => m.JobModule),
			},
			// {
			// 	path: 'daily-report',
			// 	loadChildren: () => import('./daily-report/daily-report.module').then(m => m.DailyReportModule)
			// },
			{
				path: 'company',
				loadChildren: () => import('./modules/company/company.module').then((m) => m.CompanyModule),
			},
			{
				path: 'channel',
				loadChildren: () => import('./modules/channel/channel.module').then((m) => m.ChannelModule),
			},
			{
				path: 'comment',
				loadChildren: () => import('./modules/comment/comment.module').then((m) => m.CommentModule),
			},
			{
				path: 'district',
				loadChildren: () => import('./modules/district/district.module').then((m) => m.DistrictModule),
			},
			{
				path: 'unit-of-measure',
				loadChildren: () => import('./modules/unit-of-measure/unit-of-measure.module').then((m) => m.UnitOfMeasureModule),
			},
			{
				path: 'user',
				loadChildren: () => import('./modules/user/user.module').then((m) => m.UsersModule),
			},
			{
				path: 'unit-config',
				loadChildren: () => import('./modules/unit-config/unit-config.module').then((m) => m.UnitConfigModule),
			},
			{
				path: 'output-config',
				loadChildren: () => import('./modules/output-config/output-config.module').then((m) => m.OutputConfigModule),
			},
			{
				path: 'asset',
				loadChildren: () => import('./modules/asset/asset.module').then((m) => m.AssetModule),
			},
			{
				path: 'download',
				loadChildren: () => import('./modules/download/download.module').then((m) => m.DownloadModule),
			},
			{
				path: 'version',
				loadChildren: () => import('./modules/version/version.module').then((m) => m.VersionModule),
			},
			{
				path: 'error-page', // This is a route for error page when user is logged in
				loadChildren: () => import('./modules/error/error.module').then((m) => m.ErrorModule),
			},
			{
				path: '',
				redirectTo: 'job',
				pathMatch: 'full',
			},
			{
				path: '**',
				redirectTo: 'error-page',
				pathMatch: 'full',
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always' })],
	exports: [RouterModule],
})
export class AppRoutingModule {}
